// This file--the whole app--should be refactored so that
// this module doesn't have all dependencies.
//
// We should only have a boot module, which has a minimal
// set of dependencies, and the other modules mind their
// own dependencies.

angular.module("digiexam", [
	// Good DX stuff
	"dx.webapp.accessibility",
	"dx.webapp.api",
	"dx.webapp.archive",
	// "dx.webapp.articleList",
	"dx.webapp.client",
	"dx.webapp.answer",
	"dx.webapp.class",
	"dx.webapp.cookies",
	"dx.webapp.droparea",
	"dx.webapp.error",
	"dx.webapp.event",
	"dx.webapp.exam",
	"dx.webapp.examDuration",
	"dx.webapp.examParts",
	"dx.webapp.exams",
	"dx.webapp.forgotPassword",
	"dx.webapp.import",
	"dx.webapp.importStudents",
	"dx.webapp.integrations",
	"dx.webapp.invigilator",
	"dx.webapp.jobs",
	"dx.webapp.library",
	"dx.webapp.logging",
	"dx.webapp.login",
	"dx.webapp.lti",
	"dx.webapp.masterTools",
	"dx.webapp.navigation",
	"dx.webapp.node",
	"dx.webapp.onlineResources",
	"dx.webapp.overview",
	"dx.webapp.printing",
	"dx.webapp.question",
	"dx.webapp.referral",
	"dx.webapp.region",
	"dx.webapp.register",
	"dx.webapp.results",
	"dx.webapp.roles",
	"dx.webapp.routes",
	"dx.webapp.rubrics",
	"dx.webapp.session",
	"dx.webapp.skolon",
	"dx.webapp.sorting",
	"dx.webapp.student",
	"dx.webapp.suggestionDropdown",
	"dx.webapp.support",
	"dx.webapp.share",
	"dx.webapp.time",
	"dx.webapp.user",
	"dx.webapp.wordGap",

	"dx.ui.dataTypes.grading",
	"dx.ui.dataTypes.question",
	"dx.ui.components.dialog",
	"dx.ui.components.notificationCenter",
	"dx.ui.components.onlineResources",

	"dx.ui.utils",
	"dx.ui.components.localize",
	"dx.ui.components.scroll",
	"dx.ui.components.tooltip",

	// Legacy stuff
	"digiexam.components",
	"digiexam.exam",
	"digiexam.gradingMatrix",
	"digiexam.invite",
	"digiexam.node",
	"digiexam.services.faults",
	"digiexam.services",

	"angularFileUpload",
	"focus",
	"lightbox",
	"LocalStorageModule",
	"ngAnimate",
	"ngCookies",
	"ngPasteFrom",
	"ngRaven",
	"ngRoute",
	"tools",
	"UIStateManager",

	// MIGRATION: Components that are too few to need their own module anymore
	// OR downgraded components
	"dx.webapp.migration",

	// MIGRATION: Temporary components and services created to communicate between AngularJS and Angular
	"dx.webapp.angular",
]);
